import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

window.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);
  var tables = document.querySelectorAll(".table");
  tables.forEach(function(table) {
    gsap.from(table, {
      opacity: 0,
      y: 50,
      duration: 1,
      scrollTrigger: {
        trigger: table,
        start: `-=${window.innerHeight * 1.5}px top`, // トリガーの開始位置を1画面分上にずらす
        end: "bottom center",
      }
    });
  });
});